import { logUsage } from 'owa-analytics';
import type { BeforePasteEvent, EdgeLinkPreview } from 'roosterjs-editor-types';
import {
    EDGE_LINK_PREFERRED_FORMAT,
    SHAREPOINT_COM,
    SHAREPOINT_DOGFOOD_COM,
    OFFICE_COM,
} from './constants';

export function handleEdgeLinkBeforePasteEvent(
    event: BeforePasteEvent,
    links: NodeListOf<HTMLAnchorElement>,
    images: NodeListOf<HTMLImageElement>
) {
    const linkPreview: EdgeLinkPreview = event.clipboardData?.linkPreview;
    if (
        images.length === 0 &&
        links.length === 1 &&
        linkPreview?.preferred_format === EDGE_LINK_PREFERRED_FORMAT
    ) {
        logUsage('EdgeLinkPaste', { domain: linkPreview.domain });
        if (
            linkPreview.domain === SHAREPOINT_COM ||
            linkPreview.domain === SHAREPOINT_DOGFOOD_COM ||
            linkPreview.domain === OFFICE_COM
        ) {
            const anchor: HTMLAnchorElement = links[0] as HTMLAnchorElement;
            anchor.innerText = anchor.href;
        }
    }
}
